import { saveUrl } from './regex'

const magazineUrl = (id: number, slug?: string, pageIndex?: number) => {
  const path = saveUrl(String(slug || id))
  const base = `/magazin/${path || id}/${id}`
  return Number.isInteger(pageIndex) && pageIndex !== undefined
    ? `${base}#seite-${pageIndex + 1}`
    : base
}

export default magazineUrl
